import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoLink = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Link</title>
    <path
      d="M14.41 17.899a4.38 4.38 0 0 0 1.407 1.22c1.678.917 3.84.611 5.197-.747l2.628-2.628c1.712-1.711 1.613-4.473-.053-6.14-1.666-1.666-4.304-1.888-6.14-.053l-1.506 1.498"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.644 15.968c-1.573-2.102-4.534-2.544-6.367-.71 0 0 0 0 0 0l-2.866 2.864c-1.84 1.841-1.625 4.461.054 6.14 1.666 1.666 4.178 2.126 6.122.128l1.515-1.573"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoLink;
